import { ThunkDispatch } from "redux-thunk";

import { connect } from 'react-redux';

import {
    Action,
    closeSlideNotesDialog,
    slideNotesDialogTextChanged,
    submitSlideNotesDialog,
} from '../actions';
import { getSlideNotesDialogState, State } from '../reducers';

import TextFieldDialogView from '../components/TextFieldDialogView';

interface StateProps {
    readonly open: boolean,
    readonly titleKey: string,
    readonly labelKey: string,
    readonly text: string,
}

interface DispatchProps {
    readonly onDialogCancel: () => void,
    readonly onDialogSubmit: () => void,
    readonly onTextChanged: (text: string) => void,
}


const mapStateToProps = (state: State): StateProps => {
    const { open, text } = getSlideNotesDialogState(state);
    return {
        open,
        titleKey: 'slide_notes_dialog_title',
        labelKey: 'slide_notes_dialog_label',
        text,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>): DispatchProps => (
    {
        onDialogCancel: () => {
            dispatch(closeSlideNotesDialog());
        },
        onDialogSubmit: () => {
            dispatch(submitSlideNotesDialog());
        },
        onTextChanged: (text: string) => {
            dispatch(slideNotesDialogTextChanged(text));
        },
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TextFieldDialogView);



// WEBPACK FOOTER //
// ./src/containers/SlideNotesDialog.ts